import { inject, Injectable } from '@angular/core';
import { Environment } from '@environment/environment';
import { HttpService } from '@services/http/http.service';
import Dexie, { Table } from 'dexie';
import { exportDB, ExportProgress } from 'dexie-export-import'

export interface Log {
  msg: string;
  date: string;
  id?: number;
  object: any;
  type: 'error' | 'info';
}

class LogDatabase extends Dexie {
  readonly logs!: Table<Log, number>
  constructor() {
    super('logs');
    this.version(1).stores({
      logs: '++id'
    })
  }
}

@Injectable({
  providedIn: 'root'
})
export class LogService {

  private readonly logDb = new LogDatabase();
  private readonly httpSvc: HttpService = inject(HttpService);

  async add(log: Log): Promise<number>;
  async add(logs: Log[]): Promise<number[]>;
  async add(log: Log | Log[]): Promise<number | number[]> {
    if (Array.isArray(log)) {
      return await this.logDb.logs.bulkAdd(log, { allKeys: true })
    } else {
      return await this.logDb.logs.add(log);
    }
  }

  async getLogs() {
    const logs = await this.logDb.logs.toArray();
    return logs;
  }
  async clearLogs() {
    await this.logDb.logs.clear();
  }

  async exportLogDB() {

    const data = await exportDB(this.logDb, {
      prettyJson: true,
    })
    const file = new File([data], 'logs.json', { type: data.type });
    const url = URL.createObjectURL(file);
    const a = document.createElement('a');
    a.href = url
    a.download = 'logs.json';
    a.click();
    URL.revokeObjectURL(url);
    this.logDb.logs.clear();
  }


  async uploadLog() {
    const log = await this.getLogs();
    const url = Environment.baseUrl + 'saveerrorlog';
    const response = await this.httpSvc.post([url, log], true);
  }


}
